import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { ListGroup, Button } from 'react-bootstrap';
import * as FcIcons from "react-icons/fc";
import IoT from '../../../assets/images/IoTs.png';
import Logomarca from '../../../assets/images/logoGiga.png';

import './styles.css';
import DarkVariantExample from './DarkVariantExample';

const Wifi = () => {
    const values = [true];
    const [fullscreen, setFullscreen] = useState(true);
    const [show, setShow] = useState(false);

    function handleShow(breakpoint) {
        setFullscreen(breakpoint);
        setShow(true);
    }

    return (
        <>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-sm-12 col-md-6'>
                        <div className='titulo'>
                            <h1><FcIcons.FcWiFiLogo /></h1>

                            <h2>Redes Wi-Fi - Essenciais no cotidiano</h2>
                        </div>
                        <div className='content-list'>
                            <ListGroup as="ol" numbered>
                                <ListGroup.Item as="li" className="d-flex justify-content-between align-items-start">
                                    <div className="ms-2 me-auto opcoes">
                                        <div className="fw-bold">Importancia:</div>
                                        <span>As redes Wi-Fi são fundamentais para o funcionamento diário de dispositivos pessoais e profissionais, proporcionando conectividade contínua.</span>
                                    </div>
                                </ListGroup.Item>
                                <ListGroup.Item as="li" className="d-flex justify-content-between align-items-start">
                                    <div className="ms-2 me-auto opcoes">
                                        <div className="fw-bold">Crescimento da demanda por redes rápidas e estáveis:</div>
                                        <span>A necessidade por redes de alta velocidade e estabilidade tem crescido exponencialmente com o aumento do uso de serviços online e dispositivos conectados.</span>
                                    </div>
                                </ListGroup.Item>
                                <ListGroup.Item as="li" className="d-flex justify-content-between align-items-start">
                                    <div className="ms-2 me-auto opcoes">
                                        <div className="fw-bold">Custo de investimento em tecnologia:</div>
                                        <span>O custo de investimento em roteadores modernos é significativo devido às suas capacidades avançadas, desempenho superior, segurança e longevidade.</span>
                                    </div>
                                </ListGroup.Item>
                            </ListGroup>
                            <div>
                                {values.map((v, idx) => (
                                    <Button
                                        key={idx}
                                        className="custom-margin-button w-100"
                                        onClick={() => handleShow(v)}>
                                        Ir ao conteúdo
                                        {typeof v === 'string' && `below ${v.split('-')[0]}`}
                                    </Button>
                                ))}
                                <Modal show={show} fullscreen={fullscreen} onHide={() => setShow(false)} className="custom-modal">
                                    <Modal.Header closeButton className="custom-modal-header">
                                        <Modal.Title className="custom-modal-title">
                                            {/* <h1><FcIcons.FcWiFiLogo /> */}
                                            <img src={Logomarca} alt='logomarca' className='w-50' />
                                            {/* </h1> */}
                                        </Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body className="custom-modal-body">
                                        <DarkVariantExample />
                                    </Modal.Body>
                                </Modal>
                            </div>
                        </div>
                    </div>
                    <div className='col-sm-12 col-md-6'>
                        <div>
                            {values.map((v, idx) => (
                                <Button
                                    key={idx}
                                    className="custom-margin-button w-100"
                                    onClick={() => handleShow(v)}>
                                    Ir ao conteúdo
                                    {typeof v === 'string' && `below ${v.split('-')[0]}`}
                                </Button>
                            ))}
                            <Modal show={show} fullscreen={fullscreen} onHide={() => setShow(false)} className="custom-modal">
                                <Modal.Header closeButton className="custom-modal-header">
                                    <Modal.Title className="custom-modal-title">
                                        {/* <h1><FcIcons.FcWiFiLogo /> */}
                                        <img src={Logomarca} alt='logomarca' className='w-50' />
                                        {/* </h1> */}
                                    </Modal.Title>
                                </Modal.Header>
                                <Modal.Body className="custom-modal-body">
                                    <DarkVariantExample />
                                </Modal.Body>
                            </Modal>
                        </div>
                        <div className='iot'>
                            <img src={IoT} alt='IoT' />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Wifi;
